module.exports = __webpack_public_path__ + "img/search-price.33f5509.svg";